<template>
  <td class="px-1 py-2 md:p-4">
    <a
      :href="`/products/${product.id}`"
      class="flex items-center"
    >
      <img
        v-if="productImageToShow"
        :src="productImageToShow"
        :alt="product.name"
        class="mr-3 size-12 rounded-md border border-gray-200 object-cover"
      />
    </a>
  </td>
  <td class="px-1 py-2 md:p-4">
    <div class="flex-1">
      <p class="font-medium">
        {{ product.name }}
      </p>
      <p class="text-xs text-gray-500">
        {{ product.sku }}
      </p>
    </div>
  </td>
  <td class="px-1 py-2 text-center md:p-4">
    {{ preOrderProduct.quantity }}
  </td>
  <td class="hidden px-1 py-2 text-center md:table-cell md:p-4">
    {{ useFormatCurrency(product.unitaryPriceCents) }}
  </td>
  <td class="px-1 py-2 text-center md:p-4">
    <template v-if="activeDiscount || showDiscountedAmount">
      <p v-if="showDiscountedAmount">
        {{ useFormatCurrency(productWholesalePrice) }}
      </p>
      <p class="ml-0.5 line-through">
        {{ useFormatCurrency(product.wholesalePriceCents) }}
      </p>
    </template>
    <p
      v-else
      class=""
    >
      {{ useFormatCurrency(product.wholesalePriceCents) }}
    </p>
  </td>
  <td class="px-1 py-2 text-center font-medium md:p-4">
    {{ useFormatCurrency(calculateSubtotal) }}
  </td>
</template>
<script setup lang="ts">
import { computed, watch } from 'vue';
import useProductImage from './use/product-image';
import useFormatCurrency from './use/format-currency';
import useActiveProductDiscounts from './use/active-product-discounts';
import useProductWholesalePriceMethods from './use/product-wholesale-price';

const props = defineProps<{
  preOrderProduct: PreOrderProduct;
  product: Product;
}>();

const computedQuantity = computed(() => props.preOrderProduct.quantity);
const { productWholesalePrice } = useProductWholesalePriceMethods(props.product, computedQuantity);
const { productImageToShow } = useProductImage(props.product);
const showDiscountedAmount = computed(() => productWholesalePrice.value < props.product.wholesalePriceCents);
const { activeDiscount } = useActiveProductDiscounts(props.product);

const calculateSubtotal = computed(() => {
  return productWholesalePrice.value * props.preOrderProduct.quantity;
});

const emit = defineEmits<{
  'update:totalProductsPriceCents': [value: Record<number, number>];
}>();

watch(
  calculateSubtotal,
  (newValue) => {
    emit('update:totalProductsPriceCents', { [props.product.id]: newValue });
  },
  { immediate: true },
);
</script>
